<template>
  <k-field-group language-prefix="publicApiLog.fields">
    <k-sidebar v-bind="$attrs"
               v-on="$listeners"
               :save-button-text="$t('global.applyFilter')"
               :title="$t('global.filterTitle', { module: $t('publicApiLog.title') })"
               fixed
               right
               temporary
               width="300"
               @click:confirm="handleFilterClick">
      <PublicApiEndpointSelect v-model="filters.type" field="type" clearable/>
      <KDateField v-model="filters.dateFrom" field="dateFrom" />
      <KDateField v-model="filters.dateTo" field="dateTo" />
      <KCheckbox v-model="filters.showSuccessful" field="showSuccessful" />
    </k-sidebar>
  </k-field-group>
</template>

<script>
import KFieldGroup from "@/components/crud/fields/KFieldGroup.vue";
import KDateField from "@/components/crud/fields/KDateField.vue";
import KCheckbox from "@/components/crud/fields/KCheckbox.vue";
import KSidebar from "@/components/layout/KSidebar.vue";
import PublicApiEndpointSelect from "@/components/autocompletes/PublicApiEndpointSelect.vue";

export default {
  name: 'PublicApiLogFilter',
  components: {
    PublicApiEndpointSelect,
    KSidebar,
    KFieldGroup,
    KDateField,
    KCheckbox,
  },
  inheritAttrs: false,
  props: {
    filters: {
      type: Object,
      dateFrom: String,
      dateTo: String,
      showSuccessful: Boolean,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  watch: {
    filters: {
      handler(values) {
        this.form = { ...this.form, ...values };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleFilterClick() {
      this.$emit('update:filters', this.form);
      this.$emit('input', false);
    },
  },
};
</script>
